
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weather",
      function () {
        return require("private-next-pages/weather/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weather"])
      });
    }
  